<template>
  <div id="modalAddCommodity" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-lg"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <modal-loading :show="loading"></modal-loading>
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("order.添加商品") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25">
          <form>
            <!-- 商品类型 -->
            <div class="form-group row">
              <label class="col-md-2 col-form-label form-control-sm text-right">
                {{ $t("order.商品类型：") }}
              </label>
              <div class="col-md-9 col-sm-12 d-flex align-items-center pd-0">
                <label class="rdiobox mg-b-0 mg-l-10">
                  <input
                    type="radio"
                    value="1"
                    name="protype"
                    v-model="proType"
                  />
                  <span class="pd-0">{{ $t("order.库存商品") }}</span>
                </label>
                <label class="rdiobox mg-b-0 mg-l-10">
                  <input
                    type="radio"
                    value="7"
                    name="protype"
                    v-model="proType"
                  />
                  <span class="pd-0">{{ $t("product.原料商品") }}</span>
                </label>
              </div>
            </div>
            <!-- 搜索类型 -->
            <div class="form-group row">
              <label class="col-md-2 col-form-label form-control-sm text-right">
                {{ $t("order.搜索类型：") }}
              </label>
              <div class="col-md-9 col-sm-12 d-flex align-items-center pd-0">
                <label class="rdiobox mg-b-0 mg-l-10">
                  <input
                    type="radio"
                    value="1"
                    name="searchtype"
                    v-model="searchType"
                  />
                  <span class="pd-0">{{ $t("order.SKU编号") }}</span>
                </label>
                <label class="rdiobox mg-b-0 mg-l-10">
                  <input
                    type="radio"
                    value="2"
                    name="searchtype"
                    v-model="searchType"
                  />
                  <span class="pd-0">{{ $t("rm.SKU名称") }}</span>
                </label>
              </div>
            </div>
            <!-- 搜索内容 -->
            <div class="form-group row">
              <label class="col-md-2 col-form-label form-control-sm text-right">
                {{ $t("order.搜索内容：") }}
              </label>
              <div class="col-md-9 col-sm-12 d-flex align-items-center pd-0">
                <input
                  @keyup.enter="search"
                  v-model="searchText"
                  type="text"
                  class="form-control form-control-sm tx-15 wd-60p mg-l-10"
                />
                <input id="hiddenText3" type="text" style="display: none" />
                <a
                  href="javascript:;"
                  class="btn btn-sm btn-info"
                  @click="search"
                  >{{ $t("order.搜索") }}</a
                >
              </div>
            </div>
          </form>
          <form class="mg-t-30">
            <div class="form-group row align-items-center pd-x-15">
              <div class="col-md-8 d-flex align-items-center tx-gray-900">
                <label class="ckbox mg-b-0 d-inline-block valign-middle">
                  <input
                    type="checkbox"
                    :checked="isAll"
                    @change="changeAllCheck($event)"
                  />
                  <span></span>
                </label>
                {{ $t("order.商品信息") }}
              </div>
              <div class="col-md-4 tx-gray-900">
                {{ $t("order.状态") }}
              </div>
            </div>
            <div class="pd-x-15" v-if="items.length > 0">
              <div
                style="border-bottom: 1px solid #ddd; margin-bottom: 15px"
                v-for="(item, index) in items"
                :key="index"
              >
                <div class="form-group row align-items-center">
                  <div class="col-md-8">
                    <div class="d-flex align-items-center">
                      <label class="ckbox mg-b-0 d-inline-block valign-middle">
                        <input
                          type="checkbox"
                          :value="item.sku"
                          v-model="checkArr"
                        />
                        <span></span>
                      </label>
                      <a
                        class="p-img-wrap mg-x-5"
                        href="javascript:;"
                        v-lazy:background-image="item.propertyImage"
                      >
                      </a>
                      <div class="p-info">
                        <p class="mg-b-0 tx-12">
                          <span class="tx-gray-900">{{ item.name }}</span>
                        </p>
                        <p class="mg-b-0 tx-12">
                          {{ $t("order.价格:") }}
                          <span class="tx-gray-900">{{
                            item.price ? Number(item.price).toFixed(2) : "---"
                          }}</span>
                        </p>
                        <p class="mg-b-0 tx-12 mg-r-5">
                          SKU:
                          <span class="tx-gray-900">{{
                            item.sku ? item.sku : "---"
                          }}</span>
                          <a
                            v-show="item.sku"
                            class="to-clipboard tx-info mg-l-5"
                            href="javascript:;"
                            :data-clipboard-text="item.sku"
                          >
                            <i class="icon ion-clipboard"></i>
                          </a>
                        </p>
                        <p class="mg-b-0 tx-12">
                          SPU:
                          <span class="tx-gray-900">{{
                            item.spu ? item.spu : "---"
                          }}</span>
                        </p>
                        <p class="mg-b-0 tx-12">
                          {{ $t("order.虚拟SKU:") }}
                          <span class="tx-gray-900">{{
                            item.virtualSku ? item.virtualSku : "---"
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 d-flex align-items-center">
                    <span
                      :class="item.status == 2 ? 'tx-danger' : 'tx-success'"
                      >{{ $t(status[item.status]) }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="col-12 none-product">
              <i class="fa fa-ban"></i>{{ $t("order.没有符合条件的数据") }}
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="
              btn btn-primary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            @click="saveFn"
          >
            {{ $t("order.添加") }}
          </button>
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("order.取消") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      // 商品类型
      proType: 1,
      // 搜索类型
      searchType: 1,
      // 搜索内容
      searchText: "",
      items: [],
      checkArr: [],
      // 状态
      status: arrDict.storageProStataus,
    };
  },
  computed: {
    isAll() {
      return this.checkArr.length == this.items.length && this.items.length > 0
        ? true
        : false;
    },
  },
  mounted() {
    $("#modalAddCommodity").on("hidden.bs.modal", (e) => {
      this.proType = 1;
      this.searchType = 1;
      this.searchText = "";
      this.items = [];
      this.checkArr = [];
    });
  },
  methods: {
    // 搜索
    search() {
      if (!this.searchText)
        return ShowTip(this.$t("order.请输入搜索条件"), "danger");
      let param = {
        skuType: this.proType,
        sku: this.searchType == 1 ? this.searchText : "",
        name: this.searchType == 2 ? this.searchText : "",
      };
      this.loading = true;
      $.api_call("api.SupplierProductStock.getStockBySku", param, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          this.items = r.Data.Results || [];
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    // 全选或者全不选
    changeAllCheck(e) {
      this.checkArr = [];
      if (e.target.checked) {
        this.items.forEach((e) => {
          this.checkArr.push(e.sku);
        });
      }
    },
    // 添加
    saveFn() {
      if (this.checkArr.length == 0)
        return ShowTip($t("order.请选择一个商品"), "danger");
      this.items.forEach((elem) => {
        const sku = this.checkArr.find((sku) => sku == elem.sku);
        if (sku) {
          const item = this.$parent.skuItems.find((e) => e.sku == sku) || {};
          if (JSON.stringify(item) == "{}") {
            this.$set(elem, "newquantity", 1);
            this.$parent.skuItems.push(elem);
          }
        }
      });
      $("#modalAddCommodity").modal("hide");
    },
  },
};
</script>
<style type="text/css">
.p-img-wrap {
  display: block;
  width: 60px;
  height: 60px;
  background-size: 100%;
  border: 1px solid #ddd;
}
</style>